export enum Market {
  East = 'East',
  West = 'West',
  North = 'North',
  South = 'South',
}

export enum Quarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
}

export enum ClientQuality {
  All = 'Blank',
  MuReview = 'MU Review',
  SpecialAttain = 'Special Attention',
  MarketReview = 'Market Review',
}

export enum MonthOption {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}

export const MARKETS: readonly Market[] = Object.values(Market);
export const QUARTERS: readonly Quarter[] = Object.values(Quarter);
export const CLIENT_QUALITY_OPTIONS: readonly ClientQuality[] = Object.values(ClientQuality);
export const MONTH_OPTIONS: readonly MonthOption[] = Object.values(MonthOption);

export const QUARTER_MONTH_MAP: Readonly<Record<Quarter, readonly MonthOption[]>> = {
  [Quarter.Q1]: [MonthOption.September, MonthOption.October, MonthOption.November],
  [Quarter.Q2]: [MonthOption.December, MonthOption.January, MonthOption.February],
  [Quarter.Q3]: [MonthOption.March, MonthOption.April, MonthOption.May],
  [Quarter.Q4]: [MonthOption.June, MonthOption.July, MonthOption.August],
};

/**
 * Working-day offsets for GLRR (Go-Live) field calculations.
 * Values are positive; direction is handled by addWorkingDays / subtractWorkingDays.
 */
export const GLRR_FIELD_CONFIG = {
  /** Pre Go-Live fieldwork start — subtract from Go-Live date. */
  PRE_FW_START_FROM_GO_LIVE: 55,
  /** Pre Go-Live fieldwork end date — subtract from Go-Live date. */
  PRE_FW_END_FROM_GO_LIVE: 20,
  /** Interim call date — subtract from Go-Live date. */
  INTERIM_CALL_FROM_GO_LIVE: 20,
  /** Post Go-Live fieldwork start - add to Go-Live date. */
  POST_FW_START_FROM_GO_LIVE: 10,
  /** Working days added to Post Go-Live FW end date to compute Publish Final Report (multi-location). */
  TARGET_PUB_WORKING_DAYS_MULTI: 45,
  /** Working days added to Post Go-Live FW end date to compute Publish Final Report (single location). */
  TARGET_PUB_WORKING_DAYS_SINGLE: 30,
} as const;
